// import { Select as AntSelect } from 'antd';
import Select from './Select';

export default Select;
// export const TaxarooSelect = AntSelect;
